export default __webpack_public_path__ + "static/media/logo-signin.adc604c8.svg";